import { render, staticRenderFns } from "./SubscriptionForm.vue?vue&type=template&id=4583cd22"
import script from "./SubscriptionForm.vue?vue&type=script&lang=js"
export * from "./SubscriptionForm.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionForm.vue?vue&type=style&index=0&id=4583cd22&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports